export default "__VITE_ASSET__CgOsLbnQ__"